import React, { useCallback, useEffect, useMemo, useState } from 'react'
import BiztantuLoader from '../../Components/Loader'
import { Box, Button, Stack, Tooltip, Typography } from '@mui/material'
import { CreateLeadFooter, StyledGridContainer, StyledLeadContainer, StyledSubHeader } from '../../Components/Styled'
import { handleValidateCodevalue, searchEntity } from '../../Utility/constant'
import { useDispatch, useSelector } from 'react-redux'
import { useIsMobile } from '../../Utility/hooks/useIsMobile'
import { privateRoutesPath } from '../../Routes'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import TextFiledWithLabel from '../../Components/TextFieldWithLabel'
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable'
import LeadAccordion from '../../Components/LeadAccordion'
import NumericTextField from '../../Components/NumericTextfield';
import { removeExcessiveTags } from '../../Utility/textHelper'
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action'
import { requestGetAllActiveProducts } from '../../Store/Product/action'
import { useSnackbar } from 'notistack'
import { createRequestData, getRequestData, updateRequestData } from '../../Utility/apiHelper'
import { resetState } from '../../Utility/resetSearchFunction'
import { parseCronToTime, parseTimeToDayjs } from '../../Utility/calculations'
import SendNotification from '../../Components/SendNotification'
import { AddMoreButton, RemoveAddedFieldButton } from '../../Components/AddMoreOrRemoveButton'
import FieldMappingDialog from './FieldMappingDialog'
import ApiAccessDetailsDialog from './ApiAccessDetailsDialog'
import YearlyDateRow from './YearlyDateRow'
import {
    ENTITY_TYPES,
    WORKFLOW_ACTION_TYPES,
    WORKFLOW_API_KEY_LOCATIONS,
    WORKFLOW_HTTP_METHODS,
    WORKFLOW_PROCESS_TYPES,
    WORKFLOW_SCHEDULE_MODES,
    WORKFLOW_TRIGGER_TYPES,
    defaultActionConfig,
    defaultProcessingConfig,
    getActionEntityType,
    getProcessingEntityType,
    getTriggerMode,
    getTriggerTypeForUi,
    buildTriggerConfig,
    isMetaOAuthConfig,
    updateYearlyDate,
    isTriggerValid,
    toBackendTriggerType,
    workflowActionType,
    workflowDailyFrequencies,
    workflowEventTypes,
    workflowProcessingTypes,
    workflowStatus,
    workflowTriggerTypes,
    WORKFLOW_AUTH_TYPES,
    WEEK_DAYS_OPTIONS,
    MONTH_DATES_OPTIONS,
} from '../../Utility/workflowConfig'
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet'
import RunTimeField from '../../Components/RunTimeField'
import useNavigation from '../../Utility/hooks/useNavigation'
import './workflow.css';

const CreateEditWorkflow = (props) => {
    
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const isLoadingProgress = useSelector(state => state.global.isLoading); 
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const [currentWfDetails,setCurrentWfDetail] = useState({
        status : "WORKFLOW_STATUS_DRAFT",
        scheduleMode : WORKFLOW_SCHEDULE_MODES.SINGLE_DAILY
    });
    const [processingConfigs, setProcessingConfigs] = useState([defaultProcessingConfig]);
    const [actionConfigs, setActionConfigs] = useState([defaultActionConfig]);
    const [initialWorkflowState, setInitialWorkflowState] = useState(null);
    const [openEmailDialogIndex, setOpenEmailDialogIndex] = useState(-1);
    const [openMappingDialogIndex, setOpenMappingDialogIndex] = useState(-1);
    const [openApiDialogIndex, setOpenApiDialogIndex] = useState(-1);
    const reduxActiveProducts = useSelector(state => state?.product?.activeProducts);

    const activeProducts = useMemo(() => {
        return (reduxActiveProducts || []).map(p => ({ label: p.name, value: p.id }));
    }, [reduxActiveProducts]);
    const { navigateTo,goBackTo } = useNavigation();
    const isMobile = useIsMobile();
    const dispatch = useDispatch();
    const canEdit = !!specificRolePermission?.isWorkflowManage;
    const isViewMode = !canEdit;
    const [requiredError,setRequiredError] = useState({
        name:false,
        status:false,
        triggerType:false,
        time:false,
        processing_type:false,
        days:false,
        action_type:false,
        emailDetails:false
    })
    const goBack = () =>goBackTo(`${privateRoutesPath.WORKFLOW}`,searchEntity?.workflow)
    const {enqueueSnackbar} = useSnackbar();

    const handleOnChange = (event) => {
        const { name, value } = event?.target;
        setCurrentWfDetail(prev => {
            const nextState = { ...prev, [name]: value };
            if (name === "triggerType") {
                nextState.time = null;
                nextState.scheduleDays = [];
                nextState.scheduleDates = value === WORKFLOW_TRIGGER_TYPES.YEARLY ? [""] : [];
                nextState.structuredTime = null;
            }
            return nextState;
        });
    }

    const handleAutocompleteChange = (name, newValue) => {
        setCurrentWfDetail(prev => ({
            ...prev,
            [name]: newValue || []
        }));
    };

    const setYearlyDatesList = (updater) => {
        setCurrentWfDetail(prev => {
            const currentDates = prev.scheduleDates || [];
            const nextDates = typeof updater === 'function' ? updater(currentDates) : updater;
            return {
                ...prev,
                scheduleDates: nextDates
            };
        });
    };

    const handleYearlyRowDateChange = (index, field, value) => {
        setCurrentWfDetail(prev => ({
            ...prev,
            scheduleDates: updateYearlyDate(prev.scheduleDates, index, field, value)
        }));
    };

    /** Fetch active products for the PRODUCT_SPECIFIC_CUSTOMERS processing type */
    useEffect(() => {
        const queryparams = {
            params: {
                status: "PRODUCT_STATUS_ACTIVE"
            }
        };
        dispatch(requestGetAllActiveProducts(queryparams));
    }, [dispatch]);

    const handleProcessingChange = (index, event) => {
        const { name, value, checked, type } = event?.target || {};
        if (!name) return;
        setProcessingConfigs(prev => {
            const newConfigs = [...prev];
            const nextValue = type === "checkbox" ? checked : value;
            newConfigs[index] = { ...newConfigs[index], [name]: nextValue };
            return newConfigs;
        });
    };

    const handleActionChange = (index, event) => {
        const { name, value } = event?.target || {};
        if (!name) return;
        setActionConfigs(prev => {
            const newConfigs = [...prev];
            newConfigs[index] = { ...newConfigs[index], [name]: value };
            return newConfigs;
        });
    };
    const workflowId = props.match.params.id;
    
    const getCurrentWorkflowDetails = useCallback(async () => {
        try {

            dispatch(requestShowLoader());

            const url = `${process.env.REACT_APP_BASE_URL}api/workflows/${workflowId}`;
            const response = await getRequestData(url);

            const data = response?.data;

            if (!data) return;

            const scheduleMode = data.triggerConfig?.scheduleMode || WORKFLOW_SCHEDULE_MODES.SINGLE_DAILY;
            const isStructured = [
                WORKFLOW_SCHEDULE_MODES.WEEKLY,
                WORKFLOW_SCHEDULE_MODES.MONTHLY,
                WORKFLOW_SCHEDULE_MODES.YEARLY,
            ].includes(scheduleMode);

            const nextWorkflowDetails = {
                description : data?.description,
                name: data.name,
                status: data.status,
                triggerType: getTriggerTypeForUi(data.triggerType, data.triggerConfig),
                // For cron-based modes: parse cron expression; for structured: null (time held separately)
                time: scheduleMode === WORKFLOW_SCHEDULE_MODES.DAILY_MULTIPLE_TIMES || isStructured
                    ? null
                    : parseCronToTime(data.cronExpression),
                event: data.triggerConfig?.event || '',
                scheduleMode,
                timesPerDay: data.triggerConfig?.timesPerDay || '',
                runtime: data.triggerConfig?.runtime || null,
                // Structured schedule fields
                structuredScheduleMode: isStructured ? scheduleMode : null,
                scheduleDays: (data.triggerConfig?.days || []).map(day =>
                    WEEK_DAYS_OPTIONS.find(o => o.value === day) || { name: day, value: day }
                ),
                scheduleDates: scheduleMode === WORKFLOW_SCHEDULE_MODES.YEARLY
                    ? (data.triggerConfig?.dates || [])
                    : (data.triggerConfig?.dates || []).map(date =>
                        MONTH_DATES_OPTIONS.find(o => o.value === date) || { name: String(date), value: date }
                    ),
                // Re-hydrate time picker for structured modes from the saved string (e.g. "09:00 AM")
                structuredTime: isStructured ? parseTimeToDayjs(data.triggerConfig?.time) : null,
            };

            const nextProcessingConfigs = data.processingConfig?.length
                ? data.processingConfig
                : [defaultProcessingConfig];

            const mappedActions =
            data.actionConfig?.map(a => {

                return {
                action_type: a.action_type,
                emailDetails: a.action_type === WORKFLOW_ACTION_TYPES.SEND_EMAIL
                    ? {
                        subject: a.subject,
                        body: a.body,
                        templateId: a.templateId,
                        attachments: a.attachments || [],
                        templateAttachments: a.templateAttachments || []
                    }
                    : null
                };

            }) || [];

            const nextActionConfigs = mappedActions.length
                ? mappedActions
                : [defaultActionConfig];

            setCurrentWfDetail(nextWorkflowDetails);
            setProcessingConfigs(nextProcessingConfigs);
            setActionConfigs(nextActionConfigs);
            setInitialWorkflowState(JSON.parse(JSON.stringify({
                currentWfDetails: nextWorkflowDetails,
                processingConfigs: nextProcessingConfigs,
                actionConfigs: nextActionConfigs
            })));

        } catch (error) {


        } finally {

            dispatch(requestHideLoader());

        }
    }, [dispatch, workflowId]);

    useEffect(()=>{
        if(workflowId){
            getCurrentWorkflowDetails()
        }
    },[workflowId, getCurrentWorkflowDetails])

   useEffect(() => {

  if (workflowId || initialWorkflowState) return;

  if (
    !currentWfDetails ||
    Object.keys(currentWfDetails).length === 0
  ) return;

  const state = {
    currentWfDetails,
    processingConfigs,
    actionConfigs
  };

  setInitialWorkflowState(JSON.parse(JSON.stringify(state)));

}, [currentWfDetails, processingConfigs, actionConfigs, initialWorkflowState, workflowId]);
const getWorkflowState = () => ({
  currentWfDetails,
  processingConfigs,
  actionConfigs
});

const buildProcessingPayload = (config) => {
    if (config.processing_type === WORKFLOW_PROCESS_TYPES.TASK_AGING || config.processing_type === WORKFLOW_PROCESS_TYPES.LEAD_AGING) {
        return {
            processing_type: config.processing_type,
            days: config.days
        };
    }

    if (config.processing_type === WORKFLOW_PROCESS_TYPES.THIRD_PARTY_API) {
        const isMetaOAuth = isMetaOAuthConfig(config);
        return {
            processing_type: config.processing_type,
            provider: config.provider || "",
            authType: config.authType || WORKFLOW_AUTH_TYPES.NONE,
            responseDataPath: config.responseDataPath || "",
            ...(isMetaOAuth ? {} : {
                url: config.url || "",
                method: config.method || WORKFLOW_HTTP_METHODS.GET,
                authToken: config.authToken || "",
                apiKeyLocation: config.apiKeyLocation || WORKFLOW_API_KEY_LOCATIONS.HEADER,
                apiKeyName: config.apiKeyName || "",
                apiKeyValue: config.apiKeyValue || "",
            }),
            ...(isMetaOAuth ? {
                app_id: config.app_id || "",
                app_secret: config.app_secret || "",
                page_id: config.page_id || "",
                page_name: config.page_name || "",
                page_access_token: config.page_access_token || "",
                form_id: config.form_id || "",
                form_name: config.form_name || "",
            } : {}),
        };
    }

    if (config.processing_type === WORKFLOW_PROCESS_TYPES.MAP_API_TO_LEAD) {
        return {
            processing_type: config.processing_type,
            fieldMappings: (config.fieldMappings || []).filter(row => row?.targetField && row?.sourceField)
        };
    }

    if (config.processing_type === WORKFLOW_PROCESS_TYPES.PRODUCT_SPECIFIC_CUSTOMERS) {
        return {
            processing_type: config.processing_type,
            productId: config.productId || null
        };
    }

    return {
        processing_type: config.processing_type
    };
};

const validateWorkflowConfigs = () => {

  // Check Processing Configs
  const isProcessingValid = processingConfigs.every(config => {
    if (!config.processing_type) return false;

    if (
      (config.processing_type === WORKFLOW_PROCESS_TYPES.TASK_AGING ||
       config.processing_type === WORKFLOW_PROCESS_TYPES.LEAD_AGING) &&
      !config.days
    ) {
      return false;
    }

    if (config.processing_type === WORKFLOW_PROCESS_TYPES.THIRD_PARTY_API) {
      if (isMetaOAuthConfig(config)) {
        if (!config.form_id || !config.page_access_token) return false;
      } else {
        const authType = config.authType || WORKFLOW_AUTH_TYPES.NONE;
        if (!config.url) return false;
        if (authType === WORKFLOW_AUTH_TYPES.BEARER && !config.authToken) return false;
        if (authType === WORKFLOW_AUTH_TYPES.API_KEY && (!config.apiKeyName || !config.apiKeyValue)) return false;
      }
    }

    if (config.processing_type === WORKFLOW_PROCESS_TYPES.MAP_API_TO_LEAD) {
      return config.fieldMappings?.some(row => row?.targetField && row?.sourceField);
    }

    return true;
  });

  // Check Action Configs
  const isActionValid = actionConfigs.every(config => {
    if (!config.action_type) return false;

    if (config.action_type === WORKFLOW_ACTION_TYPES.SEND_EMAIL) {
      return checkHasEmailDetails(config.emailDetails);
    }


    return true;
  });
  const triggerValid = isTriggerValid(currentWfDetails);
  const isValidNameStatus = currentWfDetails?.name && currentWfDetails?.status && currentWfDetails?.description

  return isProcessingValid && isActionValid && isValidNameStatus && triggerValid;
};

    const saveWorkflowCredentials = async (value) => {
        if(!validateWorkflowConfigs()){
            enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_MANDATORY_FIELDS"),{variant:"error"})
        setRequiredError({
            name:true,
            status:true,
            triggerType:true,
            time:true,
            processing_type:true,
            days:true,
            action_type:true,
            emailDetails:true,
            description:true
        })
        return;
        }
        try{
            dispatch(requestShowLoader())
        if (initialWorkflowState &&JSON.stringify(initialWorkflowState) ===JSON.stringify(getWorkflowState())) {
            if (value === true) {
                goBack();
            } else {
                enqueueSnackbar(
                handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"),
                { variant: "info" }
                );
            }
            return;
        }
    const triggerMode = getTriggerMode(currentWfDetails?.triggerType);
    const isStructuredTrigger = !!triggerMode;
    const triggerConfig = buildTriggerConfig(currentWfDetails, triggerMode);

    const entityType = actionConfigs.map(config => getActionEntityType(config.action_type)).find(Boolean)
        || processingConfigs.map(config => getProcessingEntityType(config.processing_type)).find(Boolean)
        || ENTITY_TYPES.TASK;

    const payload = {
        ...currentWfDetails,

        triggerType: toBackendTriggerType(currentWfDetails?.triggerType),
        cronExpression: isStructuredTrigger || currentWfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE
            ? null
            : (currentWfDetails?.time?.format ? currentWfDetails.time.format("hh:mm A") : ""),
        timezone: "Asia/Kolkata",
        triggerConfig,

        processingConfig: processingConfigs.map(c => buildProcessingPayload(c)),
        entityType,
        actionConfig: actionConfigs.map(c => ({
            ...(c.emailDetails || {}),
            action_type: c.action_type
        }))
    };

    const url = workflowId 
    ? `${process.env.REACT_APP_BASE_URL}api/workflows/${workflowId}`
    :   `${process.env.REACT_APP_BASE_URL}api/workflows`
    const response = await (
    workflowId
        ? updateRequestData(payload, url)
        : createRequestData(payload, url)
    );
        if(response?.status === 200){
            enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
               response?.data?.message ||
            (workflowId
            ? "COMMON_UPDATED_SUCCESSFULLY"
            : "COMMON_CREATED_SUCCESSFULLY")
            ),
            { variant: "success" }
            );
            
            if (value === true) {
                goBack();
                return;
            }
            if (workflowId) {
                setInitialWorkflowState(JSON.parse(JSON.stringify(getWorkflowState())));
            } else {
                setCurrentWfDetail(resetState(currentWfDetails));
                setProcessingConfigs([defaultProcessingConfig]);
                setActionConfigs([defaultActionConfig]);
                setRequiredError({ name: false, status: false });
                navigateTo(`${privateRoutesPath.CREATE_WORKFLOW}/${response?.data?.id}`,{},searchEntity?.workflow);
            }
        }
        else {
        enqueueSnackbar(
            handleValidateCodevalue(
            internationalise,
            response?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
            ),
            { variant: "error" }
        );
        }
    }
        catch(error){
        enqueueSnackbar(
            handleValidateCodevalue(
            internationalise,
            error?.response?.data?.message || "COMMON_PLEASE_TRY_AGAIN"
            ),
            { variant: "error" }
        );  
        }
        finally{
            dispatch(requestHideLoader())
        }
    }

const checkHasEmailDetails = (details) => {
  if (!details) return false;
  const { subject, body, templateId, attachments, templateAttachments } = details;

  return (
    !!subject ||
    !!removeExcessiveTags(body) ||
    !!templateId ||
    attachments?.length > 0 ||
    templateAttachments?.length > 0
  );
};

  const isStructuredTrigger = !!getTriggerMode(currentWfDetails?.triggerType);
  return (
      <BiztantuLoader open={isLoadingProgress} isChildren={true}>
        <Box className='globalBox'>
          <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'WF_EDIT_WF_DETAILS')}
          </StyledSubHeader>
          <StyledGridContainer>
            
                <TextFiledWithLabel
                    required
                    disabled={isViewMode}
                    name="name"
                    id="name"
                    error = {currentWfDetails?.name ? false : requiredError?.name}
                    value={currentWfDetails?.name}
                    label={handleValidateCodevalue(internationalise,"WF_EDIT_NAME")}
                    handleOnChange={handleOnChange}
                />
        
                <SelectBoxWithLabel
                    select
                    required={true}
                    disabled={isViewMode || !workflowId}
                    name= "status"
                    error={currentWfDetails?.status ? false : requiredError?.status}
                    value= {currentWfDetails?.status ? currentWfDetails?.status : ''}
                    label={handleValidateCodevalue(internationalise,"WF_EDIT_STATUS")} 
                    optionMenuItem={workflowStatus}
                    handleOnChange={handleOnChange}
                />
          </StyledGridContainer>
           <StyledLeadContainer>
                <TextFiledWithLabel
                    label={handleValidateCodevalue(internationalise, 'WF_EDIT_DESCRIPTION')}
                    name="description"
                    required={true}
                    error={currentWfDetails?.description ? false : requiredError?.description}
                    value={currentWfDetails?.description || ''}
                    handleOnChange={handleOnChange}
                    className="workflow-field-full"
                />
          </StyledLeadContainer>
           <LeadAccordion
                label={handleValidateCodevalue(internationalise,'WF_EDIT_TRIGGER_DETAILS')}
                defaultOpen = {true}
            >
               
          <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'WF_EDIT_TRIGGER_SUB_HEADER')}
          </StyledSubHeader> 
            <StyledGridContainer 
            className="workflow-wrapper-container"
            >
            <SelectBoxWithLabel
                    select
                    name= "triggerType"
                    disabled={isViewMode}
                    required
                    error={currentWfDetails?.triggerType ? false : requiredError?.triggerType}
                    value= {currentWfDetails?.triggerType ? currentWfDetails?.triggerType : ''}
                    label={handleValidateCodevalue(internationalise,"WF_EDIT_TRIGGER_TYPE")} 
                    optionMenuItem={workflowTriggerTypes}
                    handleOnChange={handleOnChange}
                />
            {(currentWfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.DAILY_ONCE) &&
                <RunTimeField
                    value={currentWfDetails.time}
                    label={handleValidateCodevalue(
                        internationalise,
                        "WF_EDIT_TT_TIME_BASED_TITLE"
                    )}
                    disabled={isViewMode}
                    required
                    error={!currentWfDetails.time && requiredError.time}
                    onChange={(value) =>
                        setCurrentWfDetail(prev => ({
                            ...prev,
                            time: value
                        }))
                    }
                    textFieldProps={{
                        fullWidth: true
                    }}
                />
            }
            {(currentWfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.DAILY_MULTIPLE) &&
                <SelectBoxWithLabel
                    select
                    name="timesPerDay"
                    disabled={isViewMode}
                    required
                    error={!currentWfDetails?.timesPerDay && requiredError?.time}
                    value={currentWfDetails?.timesPerDay || ''}
                    label={handleValidateCodevalue(internationalise, "WF_EDIT_TIMES_PER_DAY")}
                    optionMenuItem={workflowDailyFrequencies}
                    handleOnChange={handleOnChange}
                />
            }

            {(currentWfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.EVENT_BASED) &&
                <SelectBoxWithLabel
                    select
                    name="event"
                    disabled={isViewMode}
                    required
                    error={!currentWfDetails?.event && requiredError?.triggerType}
                    value={currentWfDetails?.event || ''}
                    label={handleValidateCodevalue(internationalise, "WF_EDIT_EVENT_TYPE")}
                    optionMenuItem={workflowEventTypes}
                    handleOnChange={handleOnChange}
                />
            }

          {isStructuredTrigger && (
            <>
                {currentWfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.WEEKLY && (
                    <>
                    <AutoCompleteComponent
                        multiple
                        limitTags={2}
                        className="workflow-schedule-autocomplete"
                        optionSet={WEEK_DAYS_OPTIONS}
                        value={currentWfDetails?.scheduleDays || []}
                        disabled={isViewMode}
                        required
                        label={handleValidateCodevalue(internationalise, "WF_EDIT_DAYS_OF_WEEK") || "Day(s) of Week"}
                        placeholder={handleValidateCodevalue(internationalise, "WF_EDIT_SELECT_DAYS") || "Select Days"}
                        onChange={(e, newValue) => handleAutocompleteChange("scheduleDays", newValue)}
                        error={!(currentWfDetails?.scheduleDays || []).length && requiredError?.time}
                    />
                    <RunTimeField
                        value={currentWfDetails.structuredTime}
                        label={handleValidateCodevalue(
                            internationalise,
                            "WF_EDIT_TT_TIME_BASED_TITLE"
                        )}
                        disabled={isViewMode}
                        required
                        error={!currentWfDetails.structuredTime && requiredError.time}
                        onChange={(value) =>
                            setCurrentWfDetail(prev => ({
                                ...prev,
                                structuredTime: value
                            }))
                        }
                        textFieldProps={{
                            className: "workflow-schedule-time"
                        }}
                    />
                    </>
                )}

                {currentWfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.MONTHLY && (
                    <>
                    <AutoCompleteComponent
                        multiple
                        limitTags={2}
                        className="workflow-schedule-autocomplete"
                        optionSet={MONTH_DATES_OPTIONS}
                        value={currentWfDetails?.scheduleDates || []}
                        disabled={isViewMode}
                        required
                        label={handleValidateCodevalue(internationalise, "WF_EDIT_DATES_OF_MONTH") || "Date(s) of Month"}
                        placeholder={handleValidateCodevalue(internationalise, "WF_EDIT_SELECT_DATES") || "Select Dates"}
                        onChange={(e, newValue) => handleAutocompleteChange("scheduleDates", newValue)}
                        error={!(currentWfDetails?.scheduleDates || []).length && requiredError?.time}
                    />
                    <RunTimeField
                    value={currentWfDetails.structuredTime}
                    onChange={(value) =>
                        setCurrentWfDetail(prev => ({
                            ...prev,
                            structuredTime: value
                        }))
                    }
                    label={handleValidateCodevalue(
                        internationalise,
                        "WF_EDIT_TT_TIME_BASED_TITLE"
                    )}
                    disabled={isViewMode}
                    required
                    error={!currentWfDetails.structuredTime && requiredError.time}
                    textFieldProps={{
                        className: "workflow-schedule-time"
                    }}
                />
                    </>
                )}

                {/* YEARLY — column of Month+Date rows, then Add More, then Run Time inline */}
            </>
          )}
          
          </StyledGridContainer>
          {isStructuredTrigger && currentWfDetails?.triggerType === WORKFLOW_TRIGGER_TYPES.YEARLY && (
    <>
        {(currentWfDetails?.scheduleDates || [""]).map((dateStr, idx) => (
            <YearlyDateRow
                key={idx}
                idx={idx}
                dateStr={dateStr}
                isFirstRow={idx === 0}
                isViewMode={isViewMode}
                requiredError={requiredError}
                handleYearlyRowDateChange={handleYearlyRowDateChange}
                setYearlyDatesList={setYearlyDatesList}
                datesCount={(currentWfDetails?.scheduleDates || [""]).length}                
                currentWfDetails = {currentWfDetails}
                setCurrentWfDetail = {setCurrentWfDetail}
                internationalise={internationalise}
            />
        ))}

        <Box className="workflow-add-row">
            <AddMoreButton
                visible={!isViewMode}
                setRows={setYearlyDatesList}
                addParams=""
            />
        </Box>
    </>
)}


            </LeadAccordion>

             <LeadAccordion
                label={handleValidateCodevalue(internationalise,'WF_EDIT_PROCESSING_DETAILS')}
                defaultOpen = {true}
            >
                
          <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'WF_EDIT_PROCESSING_SUB_HEADER')}
          </StyledSubHeader> 
          {processingConfigs.map((config, index) => (
              <StyledGridContainer
                 key={`processing-${index}`}
                 className="workflow-wrapper-container"
                >
                    <Box className="workflow-number-and-month">
                    <Typography className="workflow-number-label">
                        {index + 1}.
                    </Typography>
                    <SelectBoxWithLabel
                        select
                        name="processing_type"
                        disabled={isViewMode}
                        required
                        error = {config?.processing_type ? false : requiredError?.processing_type}
                        value={config.processing_type || ''}
                        label={handleValidateCodevalue(internationalise,"WF_EDIT_PROCESSING_TYPE")} 
                        optionMenuItem={workflowProcessingTypes}
                        handleOnChange={(e) => handleProcessingChange(index, e)}
                    />
                    </Box>
                    {(config.processing_type === WORKFLOW_PROCESS_TYPES.TASK_AGING ||
                      config.processing_type === WORKFLOW_PROCESS_TYPES.LEAD_AGING) ? (
                        <NumericTextField
                            name="days"
                            required
                            disabled={isViewMode}
                            id={`days-${index}`}
                            error = {config?.days ? false : requiredError?.days}
                            value={config.days || ''}
                            label={handleValidateCodevalue(internationalise,"WF_EDIT_PT_AGING_DAYS")}
                            handleOnChange={(e) => handleProcessingChange(index, e)}
                        />
                    ) : config.processing_type === WORKFLOW_PROCESS_TYPES.THIRD_PARTY_API ? (
                        <Tooltip 
                            title={(config.page_access_token || config.url)
                                ? handleValidateCodevalue(internationalise,"WF_TP_SHOW_ACCESS") || "View Access Details"
                                : handleValidateCodevalue(internationalise,"WF_TP_SET_ACCESS") || "Set Access Details"}
                            >
                            <Button
                                className='secondry-edit-btn btn-space workflow-action-button'
                                variant="outlined"
                                onClick={() => setOpenApiDialogIndex(index)}
                            >
                                {(config.page_access_token || config.url)
                                    ? handleValidateCodevalue(internationalise,"WF_TP_SHOW_ACCESS") || "View Access Details"
                                    : handleValidateCodevalue(internationalise,"WF_TP_SET_ACCESS") || "Set Access Details"}
                            </Button>
                        </Tooltip>
                    ) : config.processing_type === WORKFLOW_PROCESS_TYPES.MAP_API_TO_LEAD ? (
                        <Tooltip title={config.fieldMappings?.length
                            ? handleValidateCodevalue(internationalise,"WF_TP_SHOW_FIELD_MAPPING")
                            : handleValidateCodevalue(internationalise,"WF_TP_SET_FIELD_MAPPING")}
                        >
                            <Button
                                className='secondry-edit-btn btn-space workflow-action-button'
                                variant="outlined"
                                onClick={() => setOpenMappingDialogIndex(index)}
                            >
                                {config.fieldMappings?.length
                                    ? handleValidateCodevalue(internationalise,"WF_TP_SHOW_FIELD_MAPPING")
                                    : handleValidateCodevalue(internationalise,"WF_TP_SET_FIELD_MAPPING")}
                            </Button>
                        </Tooltip>
                    ) : config.processing_type === WORKFLOW_PROCESS_TYPES.PRODUCT_SPECIFIC_CUSTOMERS ? (
                        <SelectBoxWithLabel
                            select
                            required
                            disabled={isViewMode}
                            name="productId"
                            error={!config?.productId && requiredError?.processing_type}
                            value={config.productId || ''}
                            label={handleValidateCodevalue(internationalise, "WF_EDIT_PRODUCT") || "Product"}
                            optionMenuItem={activeProducts}
                            handleOnChange={(e) => handleProcessingChange(index, e)}
                        />
                    ) : (
                        <TextFiledWithLabel className="workflow-hidden-field" />
                    )}

                   <RemoveAddedFieldButton
                    setRows={setProcessingConfigs}
                    index={index}
                    visible={processingConfigs.length > 1 && !isViewMode}
                    />
                </StyledGridContainer>
                ))}
                
                    <Box className="workflow-add-row">
                        <AddMoreButton
                        visible={processingConfigs[0]?.processing_type && !isViewMode}
                        setRows={setProcessingConfigs}
                        addParams={defaultProcessingConfig}
                        />
                    </Box>
                    {openMappingDialogIndex !== -1 && (
                        <FieldMappingDialog
                            open={openMappingDialogIndex !== -1}
                            isViewMode={isViewMode}
                            defaultValues={processingConfigs[openMappingDialogIndex]?.fieldMappings || []}
                            handleCloseDialog={() => setOpenMappingDialogIndex(-1)}
                            onSave={(data) => {
                                setProcessingConfigs(prev => {
                                    const newConfigs = [...prev];
                                    newConfigs[openMappingDialogIndex] = {
                                        ...newConfigs[openMappingDialogIndex],
                                        fieldMappings: data
                                    };
                                    return newConfigs;
                                });
                                setOpenMappingDialogIndex(-1);
                            }}
                        />
                    )}
                    {openApiDialogIndex !== -1 && (
                        <ApiAccessDetailsDialog
                            open={openApiDialogIndex !== -1}
                            isViewMode={isViewMode}
                            defaultValues={processingConfigs[openApiDialogIndex] || {}}
                            handleCloseDialog={() => setOpenApiDialogIndex(-1)}
                            onSave={(data) => {
                                setProcessingConfigs(prev => {
                                    const newConfigs = [...prev];
                                    newConfigs[openApiDialogIndex] = {
                                        ...newConfigs[openApiDialogIndex],
                                        ...data
                                    };
                                    return newConfigs;
                                });
                                setOpenApiDialogIndex(-1);
                            }}
                        />
                    )}
            </LeadAccordion>
             <LeadAccordion
                label={handleValidateCodevalue(internationalise,'WF_EDIT_ACTION_DETAILS')}
                defaultOpen = {true}
            >
                
          <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'WF_EDIT_ACTION_SUB_HEADER')}
          </StyledSubHeader> 
          
{actionConfigs.map((config, index) => (
  <StyledGridContainer
  
    key={`action-${index}`}
    className="workflow-wrapper-container"
  >
    <Box className="workflow-number-and-month">
    <Typography className="workflow-number-label">
        {index + 1}.
    </Typography>
    <SelectBoxWithLabel
      select
      name="action_type"
      required
      disabled = {isViewMode}
      error = {config?.action_type ? false : requiredError?.action_type}
      value={config.action_type || ''}
      label={handleValidateCodevalue(internationalise,"WF_EDIT_ACTION_TYPE")}
      optionMenuItem={workflowActionType}
      handleOnChange={(e) => handleActionChange(index, e)}
    />
    </Box>
    {config.action_type === WORKFLOW_ACTION_TYPES.SEND_EMAIL ? (
        <Tooltip title = 
         {checkHasEmailDetails(config.emailDetails)
          ? handleValidateCodevalue(internationalise,"WF_SHOW_EMAIL_DETAILS")
          : handleValidateCodevalue(internationalise,"WF_SET_EMAIL_DETAILS")}
      >
      <Button
        className='secondry-edit-btn workflow-action-button'
        variant="outlined"
        onClick={() => setOpenEmailDialogIndex(index)}
      >
        {checkHasEmailDetails(config.emailDetails)
          ? handleValidateCodevalue(internationalise,"WF_SHOW_EMAIL_DETAILS")
          : handleValidateCodevalue(internationalise,"WF_SET_EMAIL_DETAILS")}
      </Button>
      {(requiredError?.emailDetails && !config.emailDetails) && (
  <Typography className="workflow-email-warning">
  {handleValidateCodevalue(internationalise,"WF_SET_EMAIL_DETAILS_WARNING")}
  </Typography>
)}
      </Tooltip>
    ) : (
      <TextFiledWithLabel className="workflow-hidden-field" />
    )}
        <RemoveAddedFieldButton
            setRows={setActionConfigs}
            index={index}
            visible={actionConfigs.length > 1 && !isViewMode}
        />
  </StyledGridContainer>
))}

        <Box className="workflow-add-row">
                <AddMoreButton
                    visible={actionConfigs[0]?.action_type && !isViewMode}
                    setRows={setActionConfigs}
                    addParams={defaultActionConfig}
                    />
                </Box>
        {openEmailDialogIndex !== -1 && (
              <SendNotification
                isViewMode = {isViewMode}
                    channel = "TEMPLATE_CHANNEL_EMAIL"
                  open={openEmailDialogIndex !== -1}
                  disableSubject = {false}
                  autoFillSubjectFromTemplate={true}
                  title={handleValidateCodevalue(internationalise,"WF_SET_EMAIL_DETAILS_TITLE")}
                  handleCloseDialog={() => setOpenEmailDialogIndex(-1)}
                  onSave={(data) => {
                      setActionConfigs(prev => {
                          const newConfigs = [...prev];
                          newConfigs[openEmailDialogIndex] = { ...newConfigs[openEmailDialogIndex], emailDetails: data };
                          return newConfigs;
                      });
                      setOpenEmailDialogIndex(-1);
                  }}
                  isWorkflow={true}
                  defaultValues={actionConfigs[openEmailDialogIndex]?.emailDetails || null}
              />
          )}
            </LeadAccordion>
        </Box>
        <CreateLeadFooter>
                <Stack className="workflow-trigger-config-row">
                    <Typography variant='h6'>
                        {handleValidateCodevalue(internationalise, workflowId ? 'WF_EDIT_TITLE_EDIT' : 'WF_EDIT_TITLE_CREATE')}
                    </Typography>
                    <Button className={!isMobile ? 'edit-primary btn-space' : 'edit-primary'} variant="outlined" onClick={goBack}>{handleValidateCodevalue(internationalise,'COMMON_BACK')}</Button>
                    {!isViewMode &&
                    <>
                    <Button className='edit-primary' variant="outlined" 
                    onClick={saveWorkflowCredentials}
                    >
                        {handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                    </Button>
                    {workflowId &&
                    <Button className='edit-primary btn-space' variant="outlined" 
                    onClick={()=>saveWorkflowCredentials(true)}
                    >
                        {handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}
                    </Button>
                    
                    }
                    </>
                    }
            
                </Stack>
        </CreateLeadFooter>
</BiztantuLoader>
  )
}

export default CreateEditWorkflow
